export default "__VITE_ASSET__vPL0vrS1__"